module.exports = __webpack_public_path__ + "static/media/no-messages.9d1dc60f.png";